module.exports = __webpack_public_path__ + "static/media/1.13.3c78105a.png";